import React from 'react';
import {
  Container,
  LabelsHolder,
  LabelHolder,
  Label,
  HiddenLabel,
  LogoutIcon,
  Separator,
} from 'components/canvas/components/top-right-menu/style';
import NotificationIcon from 'components/canvas/components/top-right-menu/components/notification-icon';
import LogoutConfirmationModal from 'components/canvas/components/top-right-menu/components/logout-confirmation-modal';
import { useLoggedUser } from 'state/user';
import { removeToken, removeAdminToken } from 'services/storage';
import { clearStore } from 'services/apollo-client';
import { useHistory } from 'react-router';
import { useSpring } from 'react-spring';
import { useCanvasClipboardOperations } from 'state/canvas-clipboard';
import { useQuery } from '@apollo/client';
import { fetchLoggedUserQuery } from 'graphql/user/queries/fetch-logged-user';

export default function TopRightMenu() {
  const history = useHistory();
  const modal = React.useRef<any>(null);
  const hiddenLabelRef = React.createRef();

  const { data } = useQuery(fetchLoggedUserQuery, {
    fetchPolicy: 'cache-only',
  });

  const user = data?.fetchLoggedUser?.data ?? null;

  const [fullNameLabelWidth, setFullNameLabelWidth] = React.useState(0);

  const { clearClipboard } = useCanvasClipboardOperations();

  const fullName = user?.firstName + ' ' + user?.lastName;

  const labelHolderWidthAnimation = useSpring({
    from: { width: 0 },
    to: { width: fullNameLabelWidth },
    config: { duration: 500 },
  });

  const opacityAnimation = useSpring({
    from: { opacity: 0 },
    to: { opacity: fullNameLabelWidth > 0 ? 1 : 0 },
    delay: 450,
  });

  function onConfirm() {
    removeToken();
    removeAdminToken();
    clearStore();
    clearClipboard();
    history.push('/login'); // redirect user to login page
  }

  function showLogOutModal() {
    modal.current.show();
  }

  React.useEffect(() => {
    const hiddenLabelElement = hiddenLabelRef.current as HTMLElement;
    setFullNameLabelWidth(hiddenLabelElement.getBoundingClientRect().width);
  }, [hiddenLabelRef, fullName]);

  return (
    <>
      <Container>
        <NotificationIcon style={opacityAnimation} />
        <Separator />
        <LabelsHolder>
          <HiddenLabel ref={hiddenLabelRef}>{fullName}</HiddenLabel>
          <LabelHolder style={labelHolderWidthAnimation}>
            <Label style={opacityAnimation}>{fullName}</Label>
          </LabelHolder>
        </LabelsHolder>
        <LogoutIcon onClick={showLogOutModal} />
      </Container>
    </>
  );
}
